/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  USER_UPDATE_CONFIG,
  USER_LOGGED_IN,
} from '../constants/ActionTypes';

const selected = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_USER_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data.data,
      };
    case FETCH_USER_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case USER_UPDATE_CONFIG:
      const { data: dataUpdateConfig = {} } = state;

      dataUpdateConfig.configurations = action.data;

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataUpdateConfig,
      };
    case USER_LOGGED_IN:
      const { data: dataUserLoggedIn = {} } = state;

      dataUserLoggedIn.socket = action.data.socket;

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataUserLoggedIn,
      };
    default:
      return state;
  }
};

const users = combineReducers({
  selected,
});

export default users;
